import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-more2",
  "use": "icon-more2-usage",
  "viewBox": "0 0 11.03 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.03 6\" id=\"icon-more2\">\n  <path id=\"icon-more2_更多图标\" class=\"cls-1\" d=\"M2904.98,1153.48a0.485,0.485,0,0,0,.15.35l5.01,4.99a0.5,0.5,0,0,0,.71,0l5.01-4.99a0.5,0.5,0,0,0,0-.71,0.513,0.513,0,0,0-.71,0l-4.65,4.64-4.66-4.64a0.513,0.513,0,0,0-.71,0A0.508,0.508,0,0,0,2904.98,1153.48Z\" transform=\"translate(-2905 -1153)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/svg/more2.svg
// module id = UVm7
// module chunks = 41